import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { manualContentList } from '../../store/actions/manualVerificationActions/manualContentListActions';
import { videoIdApprovalActionByAdmin, videoIdApprovalActionByAdminReset } from '../../store/actions/manualVerificationActions/videoIdApprovalActionByAdminActions';
import ConfirmationPopup from '../../components/common/ConfirmationPopup';
import StatusPopup from '../../components/common/StatusPopup';
import { downloadContentForManualMatch, downloadContentForManualMatchReset } from '../../store/actions/manualVerificationActions/downloadContentForManualMatchActions';

const ManualVerification = () => {
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().slice(0, 10));
    const [showRejectPopup, setShowRejectPopup] = useState(false);
    const [selectedContentId, setSelectedContentId] = useState(null);
    const [rejectionRemark, setRejectionRemark] = useState('');
    const [showApprovePopup, setShowApprovePopup] = useState(false);
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.manualContentListReducer);
    const videoIdApprovalState = useSelector((state) => state.videoIdApprovalActionByAdminReducer);
    const downloadContentForManualMatchStateStatus = useSelector((state) => state.downloadContentForManualMatchReducer.status);
    const downloadContentForManualMatchStateMessage = useSelector((state) => state.downloadContentForManualMatchReducer.message);
    const downloadContentForManualMatchStateData = useSelector((state) => state.downloadContentForManualMatchReducer.data);

    useEffect(() => {
        dispatch(manualContentList({
            status: "",
            videoIdSubmissionDate: selectedDate
        }));
    }, [dispatch, selectedDate]);

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleApproveClick = (contentId) => {
        setSelectedContentId(contentId);
        setShowApprovePopup(true);
    };

    const handleRejectClick = (contentId) => {
        setSelectedContentId(contentId);
        setShowRejectPopup(true);
    };

    const handleCancel = () => {
        setShowRejectPopup(false);
        setShowApprovePopup(false);
        setSelectedContentId(null);
        setRejectionRemark('');
    };

    const handleConfirmReject = () => {
        if (!rejectionRemark) {
            alert('Remark is required for rejection.');
            return;
        }
        dispatch(videoIdApprovalActionByAdmin({ contentId: selectedContentId, status: 'REJECT', rejectReason: rejectionRemark }));
        handleCancel();
    };

    const handleConfirmApprove = () => {
        dispatch(videoIdApprovalActionByAdmin({ contentId: selectedContentId, status: 'APPROVED' }));
        handleCancel();
    };

    const handleCloseStatusPopup = () => {
        dispatch(videoIdApprovalActionByAdminReset());
        dispatch(manualContentList({
            status: "",
            videoIdSubmissionDate: selectedDate
        }));
    };

    const handleDownloadContent = (contentPath) => {
        dispatch(downloadContentForManualMatch({contentPath: contentPath }));
    };

    const handleFormatDate = (dateString) => {
        const date = new Date(dateString);
        const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
        return formatted;
    };

    // useEffect(() => {
    //     if (downloadContentForManualMatchStateStatus === 200) {
    //         const link = document.createElement('a');
    //         link.href = downloadContentForManualMatchStateData;
    //         link.target = '_blank';
    //         link.download = '';
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         dispatch(downloadContentForManualMatchReset());
    //     } else {
    //         dispatch(downloadContentForManualMatchReset());
    //     }
    // }, [downloadContentForManualMatchStateData]);

    return (
        <>
            <StatusPopup
                show={videoIdApprovalState.status === 200 || videoIdApprovalState.status === 500 || videoIdApprovalState.status === 302 || videoIdApprovalState.status === 401}
                type={videoIdApprovalState.status === 200 ? 'success' : 'error'}
                message={videoIdApprovalState.message}
                onClose={handleCloseStatusPopup}
            />
            <ConfirmationPopup
                show={showRejectPopup}
                title='Do you want to "Reject" it?'
                onConfirm={handleConfirmReject}
                onCancel={handleCancel}
                isApprove={false}
            >
                <textarea
                    value={rejectionRemark}
                    onChange={(e) => setRejectionRemark(e.target.value)}
                    className="w-full p-2 border rounded mt-2 text-2xl"
                    placeholder="Remark"
                    rows="3"
                />
            </ConfirmationPopup>

            <ConfirmationPopup
                show={showApprovePopup}
                title='Do you want to "Approve" it?'
                onConfirm={handleConfirmApprove}
                onCancel={handleCancel}
                isApprove={true}
            >
            </ConfirmationPopup>

            <div className="p-5 bg-gray-100 min-h-screen">
                <div className="flex items-center justify-between bg-white rounded-lg p-6 shadow-md mb-6">
                    <h1 className="m-0 text-2xl font-bold text-gray-800">Manual Verification</h1>
                </div>
                <div className="mb-5">
                    <label htmlFor="date-filter" className="mr-2 font-medium">Video ID Submission Date:</label>
                    <input type="date" id="date-filter" value={selectedDate} onChange={handleDateChange} className="p-2 border rounded" />
                </div>
                <div className="bg-white rounded-lg shadow p-5 overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-gray-200">
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Influencer Name</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Channel Name</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Campaign Name</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Download Date</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Video ID Submission Date</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Original Content</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">YT Video</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Status</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">PP Result</th>
                                <th className="p-3 text-left border-b font-bold text-[1.4rem]">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={10} className="text-center py-5">
                                        Loading...
                                    </td>
                                </tr>
                            ) : (
                                Array.isArray(data) && data.length > 0 ? data.map((item) => (
                                    <tr key={item.contentId} className="hover:bg-gray-100">
                                        <td className="p-3 border-b text-[1.4rem]">{item.influencerName}</td>
                                        <td className="p-3 border-b text-[1.4rem]">{item.channelName}</td>
                                        <td className="p-3 border-b text-[1.4rem]">{item.campaignName}</td>
                                        <td className="p-3 border-b text-[1.4rem]">{handleFormatDate(item.firstDownloadTime)}</td>
                                        <td className="p-3 border-b text-[1.4rem]">{handleFormatDate(item.videoIdSubmittedDate)}</td>
                                        <td className="p-3 border-b text-[1.4rem]">
                                            <button onClick={() => handleDownloadContent(item.originalContentPath)} className="bg-green-500 text-white text-[1.4rem] px-3 py-1 rounded-lg">
                                                Download
                                            </button>
                                        </td>
                                        <td className="p-3 border-b text-[1.4rem]">
                                            <button onClick={() => handleDownloadContent(item.youtubeVideoPath)} className="bg-green-500 text-white text-[1.4rem] px-3 py-1 rounded-lg">
                                                Download
                                            </button>
                                        </td>
                                        <td className="p-3 border-b text-[1.4rem]">{item.status}</td>
                                        <td className="p-3 border-b text-[1.4rem]">{item.ppResult || "N/A"}</td>
                                        <td className="p-3 border-b text-[1.4rem] space-y-2">
                                            <button onClick={() => handleApproveClick(item.contentId)} className="bg-green-500 text-white text-[1.4rem] px-3 py-1 rounded-lg mr-2">Approve</button>
                                            <button onClick={() => handleRejectClick(item.contentId)} className="bg-red-500 text-white text-[1.4rem] px-3 py-1 rounded-lg">Reject</button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={10} className="text-center py-5 text-[1.4rem]">
                                            No records found.
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default ManualVerification;
